import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {  finalize, Subscription } from 'rxjs';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.page.html',
  styleUrls: ['./administration.page.scss']
})
export class AdministrationPage implements OnInit, OnDestroy {
  dataForm: FormGroup;
  dataFormSearch: FormGroup;
  private unsubscribe: Subscription[] = [];
  constructor(private formBuilder: FormBuilder, private formSearchBuilder: FormBuilder)  { }

  ngOnInit() {
    this.dataForm = this.formBuilder.group({
      name : [''],
      barcode_prefix : [''],
      client_id : [''],
      sector : [''],
      username : [''],
      password : [''],
      url_cart_validation : [''],
      url_cart_expiration  : [''],
      is_wallet  : [''],
      url_trx_identity  : [''],
      url_trx_amount  : [''],
      url_trx_confirmation  : [''],
    });

    this.dataFormSearch = this.formSearchBuilder.group({
      name : [''],
    });
  }



  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }
}
